export default __webpack_public_path__ + "img/b0db8b06b1262ff059a3b9cbed664f37.svg";